export const SITE_LOCAL_SETTINGS_KEY = 'siteLocalSettings';
export const SIDEBAR_KEY = 'sidebar';
export const CO_WRITER_BAR_KEY = 'co-writer-bar';
export const CHAT_BAR_KEY = 'chat-bar';

export const SIDEBAR_CONST = {
  minWidth: '48px',
  maxWidth: '220px',
  minExpandedWidth: '180px',
};

export const CO_WRITER_BAR_CONST = {
  minWidth: '200px',
  maxWidth: '280px',
  minExpandedWidth: '200px',
};

export const CHAT_BAR_CONST = {
  minWidth: '270px',
  maxWidth: '280px',
  minExpandedWidth: '270px',
};

export const RESIZABLE_BLOCK = {
  [SIDEBAR_KEY]: SIDEBAR_CONST,
  [CO_WRITER_BAR_KEY]: CO_WRITER_BAR_CONST,
  [CHAT_BAR_KEY]: CHAT_BAR_CONST,
};

export const defaultSiteSettings = {
  [SIDEBAR_KEY]: {
    ...SIDEBAR_CONST,
    width: SIDEBAR_CONST.maxWidth,
  },
  [CO_WRITER_BAR_KEY]: {
    ...CO_WRITER_BAR_CONST,
    width: CO_WRITER_BAR_CONST.maxWidth,
  },
  [CHAT_BAR_KEY]: {
    ...CHAT_BAR_CONST,
    width: CHAT_BAR_CONST.maxWidth,
  },
};
